var exports = {
  "kL": "AudioPlayer.module__container___ZnRmbE",
  "Md": "AudioPlayer.module__fileName___ZnRmbE",
  "NE": "AudioPlayer.module__progressSection___ZnRmbE",
  "hr": "AudioPlayer.module__progressBar___ZnRmbE",
  "Ey": "AudioPlayer.module__timeDisplay___ZnRmbE",
  "ne": "AudioPlayer.module__controls___ZnRmbE",
  "gm": "AudioPlayer.module__mainControls___ZnRmbE",
  "Rr": "AudioPlayer.module__playButton___ZnRmbE",
  "$3": "AudioPlayer.module__seekButton___ZnRmbE",
  "f6": "AudioPlayer.module__secondaryControls___ZnRmbE",
  "Wq": "AudioPlayer.module__volumeControl___ZnRmbE",
  "Sn": "AudioPlayer.module__playbackRate___ZnRmbE",
  "Hw": "AudioPlayer.module__mobile___ZnRmbE",
};

module.exports = exports;
